import { SearchOutlined } from '@ant-design/icons';
import { SubmitButton } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { Drawer, FlexRow } from '@framework/ui';
import { Button } from 'antd';
import React from 'react';
import { TopMenuIconButton } from '../menu/TopMenuIconButton';

export interface IFilterDrawerButtonProps {
  /**
   * Il Form da inserire nel Drawer
   */
  children?: React.ReactNode;
  /**
   * Funzionalità Drawer
   */
  onOpen?: () => void;
  onClose?: () => void;
  onClear?: () => void;
  open?: boolean;
  /** Se filtrata mostriamo il pulsante "Rimuovi filtri" */
  isFiltered?: boolean;
  /** Mostrare i pulsanti di ricerca */
  showFormButtons?: boolean;
}

/**
 * Pulsante e Drawer Per Mobile del Form per la ricerca di domande FrontOffice.
 */
export function FilterDrawerButton(props: IFilterDrawerButtonProps) {
  const {
    onOpen,
    onClose,
    onClear,
    open,
    isFiltered,
    children,
    showFormButtons,
  } = props;

  const { t } = useTranslation();

  return (
    <>
      <TopMenuIconButton
        icon={<SearchOutlined />}
        onClick={onOpen}
        aria-label={t('ui.apri-pannello-ricerca', 'Apri pannello di ricerca')}
        id="filter-drawer-button"
        aria-expanded={open}
        aria-controls="filter-drawer-panel"
      />

      <Drawer
        id="filter-drawer-panel"
        height={'100%'}
        title={t('ui.filtri-di-ricerca', 'Filtri di ricerca')}
        onClose={onClose}
        open={open}
        placement="top"
      >
        {children}

        {showFormButtons && (
          <FlexRow
            gutter={24}
            left={
              isFiltered ? (
                <Button size="large" htmlType="reset" onClick={onClear}>
                  {t('ui.rimuovi-filtri', 'Rimuovi Filtri')}
                </Button>
              ) : undefined
            }
          >
            <SubmitButton
              isOutsideForm
              pristineMessage={t(
                'ui.nessun-filtro-modificato',
                'Nessun filtro modificato',
              )}
              block
              type="primary"
              icon={<SearchOutlined aria-hidden />}
              children={t('ui.cerca', 'Cerca')}
            />
          </FlexRow>
        )}
      </Drawer>
    </>
  );
}
